import {
  klinesLoad,
  gameLoad,
  cupLoad,
  cupPlayerLoad,
  playerLoad,
  gameActionSubmit,
  realityRankLoad
} from '../../../../services/api'

import {
  UPDATE_KLINES,
  UPDATE_GAME,
  UPDATE_CUP,
  UPDATE_CUP_PLAYER,
  UPDATE_PLAYER,
  UPDATE_NEXT_TRADING_DAY,
  UPDATE_GAMES,
  UPDATE_PLAY_CUP_ID,
  UPDATE_PLAY_GAME_ID,
  UPDATE_PLAY_KLINES,
  UPDATE_REALITY_RANKS,
  UPDATE_USERS,
  UPDATE_MY_RANK
} from '../../../mutation-types'
import {
  gamesLoad
} from '../../../../services/api';



// 实盘：擂台信息
async function loadCup({
  rootGetters,
  commit
}, {
  cupId
}) {
  const {
    realityCupId
  } = rootGetters
  cupId = +cupId || realityCupId
  const R = await cupLoad({
    cupId: cupId
  })
  const {
    nextTradingDay,
    cupInfo
  } = R

  commit(UPDATE_CUP, cupInfo)

  if (cupId === realityCupId) {
    commit(UPDATE_NEXT_TRADING_DAY, {
      cupId,
      nextTradingDay
    })
  }

  return cupInfo
}

async function loadKlines({
  commit
}, {
  cupId,
  kid
}) {
  const R = await klinesLoad({
    cupId,
    kid
  })
  const klines = R.klines
  commit(UPDATE_KLINES, {
    cupId,
    kid,
    klines
  })
  return klines
}


// 实盘：获取玩家擂台信息
async function loadCupPlayer({
  commit
}, {
  cupId,
  uid
}) {
  const R = await cupPlayerLoad(uid > 0 ? {
    cupId,
    uid
  } : {
    cupId
  })
  const cupPlayer = R.cupPlayerInfo

  commit(UPDATE_CUP_PLAYER, cupPlayer)
  return cupPlayer
}


// 实盘：玩家信息
async function loadPlayer({
  commit
}, {
  cupId,
  uid
}) {

  const R = await playerLoad(uid > 0 ? {
    cupId,
    uid
  } : {
    cupId
  })
  const player = R.playerInfo
  commit(UPDATE_PLAYER, player)

  return player
}

// 局信息
async function loadGame({
  commit
}, {
  cupId,
  gameId,
  tradingDay
}) {
  const gameInfo = await gameLoad({
    cupId,
    gameId,
    tradingDay
  })

  // console.log(gameInfo);
  // TODO: 是否更新
  commit(UPDATE_GAME, gameInfo)
  return gameInfo
}

// 局列表
async function loadGames({
  commit
}, {
  cupId
}) {

  const {
    gameInfoList
  } = await gamesLoad({
    cupId
  })

  // console.log(gameInfoList);
  // TODO: 是否更新
  commit(UPDATE_GAMES, gameInfoList)
  return gameInfoList
}

// 加载game做题目信息
async function loadPlay(args, {
  cupId, // 必选
  gameId, // 可选
  kid // 可选
}) {
  const {
    getters,
    commit,
    dispatch
  } = args

  // alert(cupId)

  cupId = +cupId
  gameId = +gameId
  kid = +kid

  const cup = await dispatch('loadCup', {
    cupId: cupId
  })
  commit(UPDATE_PLAY_CUP_ID, {
    cupId
  })

  // await loadCup(args, {
  //   cupId: cupId
  // })

  const {
    isValidKid
  } = getters

  // alert(Object.keys(args))

  gameId = +gameId
  kid = +kid

  let gameInfo
  if (!gameId) {
    let tradingDay = cup.nextTradingDay
    if (tradingDay) {
      gameInfo = await dispatch('loadGame', {
        cupId,
        tradingDay
      })
    } else {
      throw 'nextTradingDay is null'
    }
  } else {
    gameInfo = await dispatch('loadGame', {
      cupId,
      gameId
    })
  }

  gameId = gameInfo.gameId
  commit(UPDATE_PLAY_GAME_ID, {
    cupId,
    gameId
  })

  const uid = gameInfo.uid

  await dispatch('loadCupPlayer', {
    cupId,
    uid
  })

  if (!kid) {
    kid = getters.nextWaitKid
  }

  let klines = []
  if (kid > 0) {
    // TODO: 判断 kid 是否为合法 kid, 即是否在cupPlayer.kids中
    if (isValidKid(kid)) {
      klines = await loadKlines(args, {
        cupId,
        kid
      })
    } else {
      throw `kid is illegal: ${kid}`
    }
  } else {
    kid = 0
  }

  // alert(JSON.stringify({
  //   uid,
  //   cupId,
  //   gameId,
  //   kid
  // }))
  commit(UPDATE_PLAY_KLINES, {
    gameId,
    kid,
    klines
  })

  return {
    uid,
    cupId,
    gameId,
    kid,
    klines
  }
}


async function submitAction({
  dispatch
}, {
  cupId,
  gameId,
  kid,
  predictPer,
  predictVal
}) {
  cupId = +cupId
  kid = +kid
  gameId = +gameId
  // if (state.cupId !== cupId || state.kid !== kid) { // 数据不统一
  //   alert('数据不统一：' + JSON.stringify({
  //     input: {
  //       cupId,
  //       kid,
  //       predictPer
  //     },
  //     state: {
  //       cupId: state.cupId,
  //       gameId: state.gameId,
  //       kid: state.kid
  //     }
  //   }, null, 2))
  // }
  // 提交猜测结果
  const r = await gameActionSubmit({
    cupId,
    gameId,
    kid,
    predictPer,
    predictVal
  })

  // console.log(object);

  // 重新加载
  await dispatch('loadGame', {
    cupId,
    gameId
  })

  return r
}


async function loadRank({
  commit
}, {
  cupId
}) {
  const R = await realityRankLoad({
    cupId
  })
  const {
    myRank,
    rankList,
    userMap
  } = R
  commit(UPDATE_MY_RANK, myRank)
  commit(UPDATE_REALITY_RANKS, rankList)
  commit(UPDATE_USERS, userMap)

  return rankList
}


export default {
  loadPlayer,
  loadCup,
  loadCupPlayer,
  loadKlines,
  loadGame,
  loadGames,
  loadRank,
  submitAction,
  loadPlay
}
